'use client';

import { type ComponentProps, type MouseEvent, useCallback } from 'react';

import ContentCardsSection from '@/components/sections/ContentCardsSection/ContentCardsSection';

const TREATMENTS_SECTION_ID = 'pharmacist_advices_treatment_section';

type EverydayHealthSupportBookingWrapperProps = {
  data: ComponentProps<typeof ContentCardsSection>['data'];
  className?: string;
};

const isPharmacyBookingLink = (href?: string | null, label?: string | null) => {
  const cleanHref = href?.trim();
  const cleanLabel = label?.replace(/\s+/g, ' ').trim().toLowerCase();

  return (
    cleanHref === '/book-appointment' ||
    cleanHref === '/pharmacy/book' ||
    cleanHref?.startsWith('/pharmacy/book?') ||
    cleanLabel === 'book an appointment'
  );
};

const scrollToTreatments = () => {
  const el = document.getElementById(TREATMENTS_SECTION_ID);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
};

const EverydayHealthSupportBookingWrapper = ({
  data,
  className = '',
}: EverydayHealthSupportBookingWrapperProps) => {
  const handleClickCapture = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      const clickable =
        event.target instanceof Element
          ? event.target.closest('a, button')
          : null;

      if (!clickable) return;

      const href = clickable.getAttribute('href');
      const label = clickable.textContent;

      if (!isPharmacyBookingLink(href, label)) return;

      event.preventDefault();
      event.stopPropagation();

      scrollToTreatments();
    },
    [],
  );

  return (
    <div onClickCapture={handleClickCapture}>
      <ContentCardsSection
        data={data}
        className={className}
        testIdPrefix="everyday-health-support"
      />
    </div>
  );
};

export default EverydayHealthSupportBookingWrapper;
